import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { es } from "date-fns/locale";

export const NewDateFilters = ({ filters, setFilters, handleChangeDate, compact = false }) => {
  return (
    <>
      {compact ? (
        <label className="tasks-period-control">
          <span>Periodo</span>
          <select
            className="form-select"
            value={filters.time || "all"}
            onChange={({ target: { value } }) =>
              setFilters((current) => ({
                ...current,
                time: value,
                estado: value === "all" || value === "today" ? "" : current.estado,
                page: 1,
              }))
            }
          >
            <option value="all">Todos los periodos</option>
            <option value="today">Hoy</option>
            <option value="week">Esta semana</option>
            <option value="late">Vencidas</option>
            <option value="month">Por mes</option>
            <option value="range">Rango de meses</option>
            <option value="someday">Algún día</option>
            {filters.time === "year" && <option value="year">Por año</option>}
          </select>
        </label>
      ) : (
        <div className="row mt-3">
          <div className="col text-start">
            <div
              className="btn-group"
              role="group"
              aria-label="Basic radio toggle button group"
            >
              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio1"
                autoComplete="off"
                checked={filters.time === "all" && "checked"}
                onChange={() =>
                  setFilters({ ...filters, time: "all", estado: "" })
                }
              />
              <label
                className="btn btn-outline-light"
                htmlFor="btnradio1"
                style={{ color: filters.time === "all" ? "#8E24AA" : "#595759" }}
              >
                Todos
              </label>

              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio2"
                autoComplete="off"
                checked={filters.time === "today" && "checked"}
                onChange={() =>
                  setFilters({ ...filters, time: "today", estado: "" })
                }
              />
              <label
                className="btn btn-outline-light"
                htmlFor="btnradio2"
                style={{
                  color: filters.time === "today" ? "#8E24AA" : "#595759",
                }}
              >
                Hoy
              </label>

              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio3"
                autoComplete="off"
                checked={filters.time === "week" && "checked"}
                onChange={() => setFilters({ ...filters, time: "week" })}
              />
              <label
                className="btn btn-outline-light"
                htmlFor="btnradio3"
                style={{ color: filters.time === "week" ? "#8E24AA" : "#595759" }}
              >
                Esta semana
              </label>

              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio4"
                autoComplete="off"
                checked={filters.time === "month" && "checked"}
                onChange={() => setFilters({ ...filters, time: "month" })}
              />
              <label
                className="btn btn-outline-light"
                htmlFor="btnradio4"
                style={{
                  color: filters.time === "month" ? "#8E24AA" : "#595759",
                }}
              >
                Mensual
              </label>

              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio5"
                autoComplete="off"
                checked={filters.time === "range" && "checked"}
                onChange={() => setFilters({ ...filters, time: "range" })}
              />
              <label
                className="btn btn-outline-light"
                htmlFor="btnradio5"
                style={{
                  color: filters.time === "range" ? "#8E24AA" : "#595759",
                }}
              >
                Rango
              </label>

              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio6"
                autoComplete="off"
                checked={filters.time === "late" && "checked"}
                onChange={() => setFilters({ ...filters, time: "late" })}
              />
              <label
                className="btn btn-outline-light"
                htmlFor="btnradio6"
                style={{ color: filters.time === "late" ? "red" : "#595759" }}
              >
                Atrasados
              </label>

              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio7"
                autoComplete="off"
                checked={filters.time === "someday" && "checked"}
                onChange={() => setFilters({ ...filters, time: "someday" })}
              />
              <label
                className="btn btn-outline-light"
                htmlFor="btnradio7"
                style={{ color: filters.time === "someday" ? "red" : "#595759" }}
              >
                Algún día
              </label>
            </div>
          </div>
        </div>

      )}

      {filters.time === "year" && (
        <div className="mt-4 p-text-date-year ms-1">
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year"]}
              label="Año"
              openTo="year"
              onChange={(value) => handleChangeDate(value, "fecha_desde")}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "month" && (
        <div className={compact ? "tasks-period-dates" : "mt-4 p-text-date-month ms-1"}>
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year", "month"]}
              label="Mes"
              openTo="month"
              value={filters.fecha_desde}
              onChange={(value) => handleChangeDate(value, "fecha_desde")}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "range" && (
        <div className={compact ? "tasks-period-dates" : "row mt-4"}>
          <div className={compact ? "tasks-period-range" : "col text-start d-flex justify-content-start p-text-date-range ms-1"}>
            <span>
              <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["year", "month"]}
                  label="Mes desde"
                  openTo="month"
                  value={filters.fecha_desde}
                  onChange={(value) => handleChangeDate(value, "fecha_desde")}
                  renderInput={(params) => (
                    <TextField {...params} helperText={null} />
                  )}
                />
              </LocalizationProvider>
            </span>
            <span style={compact ? undefined : { marginLeft: "10px" }}>
              <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["year", "month"]}
                  label="Mes hasta"
                  openTo="month"
                  value={filters.fecha_hasta}
                  onChange={(value) => handleChangeDate(value, "fecha_hasta")}
                  renderInput={(params) => (
                    <TextField {...params} helperText={null} />
                  )}
                />
              </LocalizationProvider>
            </span>
          </div>
        </div>
      )}
    </>
  );
};
